var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M662 98L662 126",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 662.5,
    cy: 93.3333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M657.987 93.1898C657.987 89.2835 661.288 86.1168 665.358 86.1168C665.943 86.1168 666.511 86.1841 667.056 86.3076C665.742 85.4804 664.187 85 662.519 85C657.814 85 654 88.8056 654 93.5C654 98.1944 657.814 102 662.519 102C664.814 102 666.895 101.093 668.427 99.6205C667.492 100.032 666.454 100.263 665.358 100.263C661.288 100.263 657.987 97.0961 657.987 93.1898Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M671.402 92.6003L671.37 90.1461L669.535 91.7189L667.304 91.0564L668.112 93.3367L666.765 95.3813L669.1 95.2179L670.499 97.144L671.133 94.7627L673.345 93.9085L671.402 92.6003Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch5);
export default __webpack_public_path__ + "static/media/church_5.a18ad22ea2f3d8a4b78bb95334d4fb81.svg";
export { ForwardRef as ReactComponent };